import DefaultRouter from './DefaultRouter';
import DetailRouter from './DetailRouter';

const DefaultView = () => import('../views/DefaultView');
const DetailView = () => import('../views/DetailView');

export default [
    {
        path:      'units',
        component: DefaultRouter,
        children:  [
            {
                path:      '',
                name:      'project-unit-default',
                component: DefaultView,
            }, {
                path:      'u',
                component: DetailRouter,
                children:  [
                    {
                        path:      ':unitId',
                        name:      'project-unit-detail',
                        component: DetailView,
                    }
                ]
            }
        ]
    }
]
